import { Box } from '@domain-group/suit-theme'

import type { AttachmentModel, AttachmentTag } from '@models/types'

import TagContainer from '../TagContainer'

import styles from './styles.module.scss'

interface PagePreviewProps {
  attachment: AttachmentModel,
  tags: AttachmentTag[],
}

const PagePreview = (props: PagePreviewProps) => {
  const { attachment, tags } = props

  // @ts-expect-error
  const imageUrl = attachment?.links?.original_url
  // @ts-expect-error
  const height = attachment?.dimensions?.original?.height ?? 0
  // @ts-expect-error
  const width = attachment?.dimensions?.original?.width ?? 0

  return (
    <Box
      backgroundImage={`url(${imageUrl})`}
      border="1px solid"
      borderColor="lineColor"
      boxShadow="2px 2px 10px rgb(0, 0, 0, 0.1)"
      className={styles.root}
      height={height}
      marginX="auto"
      marginY="large"
      width={width}
    >
      <TagContainer height={height} width={width} tags={tags} />
    </Box>
  )
}

export default PagePreview
